import styled, { css } from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';
import { FlexColumn } from '../../../../styled/common';
import { AuthorManagementBlockWrapper } from '../blocks/AuthorManagementBlock/styled';
import { StyledSpaceSection } from '../../SpaceSection/styled';
import { PlaceholderBlock } from '../../../../styled/placeholders.styled';

export const CurrentItemColumnLayout = styled.div`
  margin-bottom: 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    margin-bottom: 0;
    padding-bottom: 30px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: flex;
    gap: 20px;
    padding: 0 40px 30px;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    padding: 0 20px 30px;
  }
`;

export const HiddenOnDesktopBlock = styled.div`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: none;
  }
`;

export const HiddenOnMobileBlock = styled.div`
  @media (max-width: ${Breakpoints.tablet}px) {
    display: none;
  }
`;

export const MobileBlock = styled.div`
  @media (min-width: ${Breakpoints.tablet}px) {
    display: none;
  }
`;
export const DeskBlock = styled.div`
  @media (max-width: ${Breakpoints.smallDesktop}px) {
    display: none;
  }
`;

export const LeftColumn = styled.div`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    flex: 2;
    overflow: hidden;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    width: 630px;
  }
`;

export const RightColumnWrapper = styled.div`
  position: relative;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    flex: 1;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    width: 310px;
  }
`;

export const RightColumnPlaceholder = styled(PlaceholderBlock)`
  width: 100%;
`;

export const RightColumn = styled(FlexColumn)<{ $isHeaderFixed: boolean }>`
  position: sticky;
  top: ${({ $isHeaderFixed }) => ($isHeaderFixed ? '90px' : '5px')};

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    gap: 15px;
  }
`;

export const operationButtonStyles = css`
  margin-bottom: 25px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    margin-bottom: 0;
  }
`;

export const PriceAndContactsBlockWrapper = styled(
  AuthorManagementBlockWrapper
)`
  ${StyledSpaceSection} {
    background-color: transparent;
  }
`;

export const ReportSectionWrapper = styled(StyledSpaceSection)`
  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    display: none;
  }
`;
